import { Coupon } from '@dtx-company/true-common/src/types/Coupon'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { SubscriptionServiceCoupon } from '../types/models/SubscriptionServiceCoupon'

interface MigrateSubscriptionServiceCouponOptions {
  /**
   * The "code" used to retrieve the coupon must be supplied so it can be correctly assigned
   * as the ID. The code is not case-sensitive so will be lowercase for the coupon id.
   *
   * In the future, ID should come from the API and the "code" may be a coupon id or one
   * of many promotional codes that may be created for any given coupon.
   */
  code: string

  /**
   * The plans passed if `{ include: { plans: true } }` was passed
   */
  plans?: Plan[]
}

export function migrateSubscriptionServiceCoupon(
  jsonCoupon: SubscriptionServiceCoupon,
  { code, plans }: MigrateSubscriptionServiceCouponOptions
): Coupon {
  return {
    id: code.toLocaleLowerCase(),
    percentOff: jsonCoupon.percentOff || 0,
    planIds: jsonCoupon.plans || [],
    plans
  }
}
